export function getISOWeek(date) {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  const weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  return { year: d.getUTCFullYear(), week: weekNo };
}

export function formatWeek({ year, week }) {
  return `${year}-W${String(week).padStart(2, "0")}`;
}

export function currentWeek() {
  return formatWeek(getISOWeek(new Date()));
}

function parseWeek(str) {
  const [y, w] = str.split("-W");
  return { year: parseInt(y, 10), week: parseInt(w, 10) };
}

function isoWeekMonday(year, week) {
  const simple = new Date(Date.UTC(year, 0, 4));
  const dayNum = simple.getUTCDay() || 7;
  const monday = new Date(simple);
  monday.setUTCDate(simple.getUTCDate() - dayNum + 1 + (week - 1) * 7);
  return monday;
}

export function addWeeks(weekStr, delta) {
  const { year, week } = parseWeek(weekStr);
  const monday = isoWeekMonday(year, week);
  monday.setUTCDate(monday.getUTCDate() + delta * 7);
  return formatWeek(getISOWeek(monday));
}

export function weekRangeLabel(weekStr) {
  const { year, week } = parseWeek(weekStr);
  const monday = isoWeekMonday(year, week);
  const sunday = new Date(monday);
  sunday.setUTCDate(monday.getUTCDate() + 6);
  const fmt = (d) =>
    `${d.getUTCDate()} ${["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"][d.getUTCMonth()]}`;
  return `${fmt(monday)} – ${fmt(sunday)} ${year}`;
}
